var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline"}},[_c('yi_curd_table',_vm._b({ref:"yt",attrs:{"name":_vm.$options.name,"getUrl":"/web/supplier/page","getKey":"rows","columns":_vm.columns}},'yi_curd_table',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }